import React, { memo, useEffect, useState } from "react";

import styles from "./shareCard.scss";

const shareCard: React.FC = () => {
  const [qrCodeUrl, setQrCodeUrl] = useState("");

  useEffect(() => {
    const canvasEl = document.querySelector<HTMLCanvasElement>(".off_screen_canvas");
    canvasEl?.dataset?.remoteUrl && setQrCodeUrl(canvasEl.dataset.remoteUrl);
  }, []);

  return (
    <div className={styles.code_wrapper}>
      <img className={styles.code} src={qrCodeUrl} />
    </div>
  );
};

export default memo(shareCard);
